<template>
  <h1>misty1999 sandbox</h1>
  <router-link to="/profile">プロフィール</router-link>
</template> 